import React from "react";
import {
    Grid,
    Typography,
    Button,
    Stack,
    Box,

} from "@mui/material";
import passwordResetModel, {passwordResetModelType} from '../../forms/models/passwordResetModel';
import passwordResetSchema from '../../forms/schemas/passwordResetSchema';
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import LoadingCover from "components/common/LoadingCover";
import PasswordResetFields from "components/forms/PasswordResetFields";
import { styled } from "@mui/material/styles";
import { LockReset } from "@mui/icons-material";

type MyFormValues = passwordResetModelType

const passwordResetModelInitial = passwordResetModel.initialValues

const passwordResetFormSchema = Yup.object().shape({...passwordResetSchema})

const IconContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
});

const ResetIcon = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
    borderRadius: '50%',
    padding: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
}));

const StyledButton = styled(Button)(() => ({
    padding: '12px',
    borderRadius: '8px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
    },
}));

interface OwnProps {
    sendReset: (newPassword: string) => void ;
    isLoading: boolean;
    apiError?: string
}

const ResetPasswordForm = (props: OwnProps) => {
    const {sendReset, isLoading, apiError} = props

    const handleSubmit = async (values: MyFormValues) => {
        sendReset(values.password)
    }
    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
            <IconContainer>
                <ResetIcon>
                    <LockReset sx={{ color: 'white', fontSize: 28 }} />
                </ResetIcon>
            </IconContainer>

            <Typography 
                variant="h5" 
                fontWeight="600" 
                color="primary" 
                align="center" 
                gutterBottom 
                data-cy="resetRequestHeader"
            >
                Reset Your Password
            </Typography>

            <Typography 
                variant="body2" 
                color="text.secondary" 
                align="center" 
                sx={{ mb: 4 }}
            >
                Please enter your new password below
            </Typography>

            <Formik
                initialValues={passwordResetModelInitial}
                onSubmit={handleSubmit}
                validationSchema={passwordResetFormSchema}
            >
                <Form data-cy={passwordResetModel.formId} style={{ width: '100%', maxWidth: '400px' }}>
                    <Stack spacing={4} width='100%' alignItems="center">
                        <PasswordResetFields 
                            apiError={apiError}
                        />

                        <StyledButton
                            variant="contained"
                            type="submit"
                            fullWidth
                            size="large"
                            data-cy={"resetRequestSubmit"}
                        >
                            Reset Password
                        </StyledButton>
                    </Stack>
                </Form>
            </Formik>

            {isLoading && <LoadingCover />}
        </Grid>
    )
}

export default ResetPasswordForm;
